"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatTimerValue = void 0;
var formatTimerValue = exports.formatTimerValue = function formatTimerValue(ms) {
  var totalSeconds = Math.floor(ms / 1000);
  var hours = Math.floor(totalSeconds / 3600);
  var minutes = Math.floor(totalSeconds % 3600 / 60);
  var seconds = totalSeconds % 60;
  var pad = function pad(n) {
    return n.toString().padStart(2, '0');
  };
  return "".concat(pad(hours), ":").concat(pad(minutes), ":").concat(pad(seconds));
};